<template>
  <div id="app" class="h-100" :class="[skinClasses]">
    <component :is="layout">
      <router-view />
    </component>
    <!-- <b-button
      class="fixed-bottom ml-auto"
      style="right: 0; left: auto; bottom: 15px; border-radius: 10px 0px 0px 10px"
    >
      Клиент
    </b-button> -->
  </div>
</template>

<script>
// import { BButton } from 'bootstrap-vue'
// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { provideToast } from 'vue-toastification/composition'
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { useWindowSize, useCssVar } from '@vueuse/core'
import { localize } from 'vee-validate'
import useJwt from '@/auth/jwt/useJwt'
import store from '@/store'
import ru from '@/libs/i18n/vee-validate/ru.json'
import en from '@/libs/i18n/vee-validate/en.json'
import uz from '@/libs/i18n/vee-validate/uz.json'

const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () =>
  import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')

export default {
  components: {
    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
    // BButton,
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
  },
  watch: {
    '$i18n.locale': async function(newVal) {
      if (this.$i18n.locale === 'uz') {
        localize(this.$i18n.locale, uz)
      } else if (this.$i18n.locale === 'ru') {
        localize(this.$i18n.locale, ru)
      } else if (this.$i18n.locale === 'en') {
        localize(this.$i18n.locale, en)
      }
      const { id } = useJwt.getUserData()
      store
        .dispatch('users/EDIT_USER', { id, language: newVal })
        .then((resp) => {
          useJwt.setUserData(resp.data)
          this.$_successToast(this.$t('generals.language_changed'))
        })
    },
  },
  mounted() {
    if (this.$i18n.locale === 'uz') {
      localize(this.$i18n.locale, uz)
    } else if (this.$i18n.locale === 'ru') {
      localize(this.$i18n.locale, ru)
    } else if (this.$i18n.locale === 'en') {
      localize(this.$i18n.locale, en)
    }
  },
  beforeCreate() {
    // Set colors in theme
    const colors = [
      'primary',
      'secondary',
      'success',
      'info',
      'warning',
      'danger',
      'light',
      'dark',
    ]

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(
        `--${colors[i]}`,
        document.documentElement
      ).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(
        useCssVar(
          `--breakpoint-${breakpoints[i]}`,
          document.documentElement
        ).value.slice(0, -2)
      )
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, (val) => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
    }
  },
}
</script>
